import { Skeleton, Typography } from "antd";
import { useTranslation } from "react-i18next";
import { DASHBOARD_RANGLARI } from "./palette";

const { Text } = Typography;

/**
 * ⚠️ Chegaralar B ning `width_bucket(late_minutes, ARRAY[6,16,31,61])`
 * iga mos: 60 daqiqa «31-60» ga tegishli, «60+» ga EMAS.
 *
 * ⚠️ P7 i18n: yorliqlar `dashboard:lateness.buckets` massividan
 * (`useTranslation` `returnObjects` ATAYLAB EMAS — massiv o'lchami
 * tilga bog'liq emasligi uchun `t("lateness.buckets", { returnObjects:
 * true })` ishlatiladi, pastdagi izohga qarang).
 */

/** Kanvasdagi eng baland ustun (`Main.dc.html:307`). */
const MAX_BALANDLIK = 72;

const PAKET_SONI = 5;

export interface LatenessHistogramProps {
	/** ⚠️ Uzunlik B tomonidan KAFOLATLANMAYDI (`number[]`, kortej emas). */
	paketlar: number[] | undefined;
	/**
	 * ⚠️⚠️ Sarlavha sanog'i AYNAN shundan, `paketlar` YIG'INDISIDAN
	 * EMAS. Ikkalasi ham `late_minutes > 0` predikatidan kelib chiqadi,
	 * ya'ni ular teng bo'lishi SHART — teng bo'lmasa bu B tomondagi
	 * nuqson. Yig'indi ishlatilsa nuqson KO'RINMAS bo'lardi.
	 */
	kechikkan: number;
	loading?: boolean;
}

/**
 * Kechikish taqsimoti — kutubxonasiz gistogramma (beshta `div`).
 *
 * ⚠️ **Komponent AntD `Card` ni O'ZI YARATMAYDI** — u sahifada
 * `SplitBar` bilan BITTA kartaga joylashadi (kanvasda ham shunday:
 * diagramma, ajratgich, keyin «Hudud holati»).
 *
 * ⚠️ **Ustun rangi — `DASHBOARD_RANGLARI.kechikkan` (binafsha),
 * kanvasning ko'ki EMAS.** Ko'k palitra jadvalida «Kelgan» ga
 * biriktirilgan; kechikish diagrammasi «Kechikkan» plitkasi va davomat
 * lentasi bilan bir xil rang olishi kerak, aks holda bitta panelda
 * bitta ma'no ikki rang olardi.
 *
 * ⚠️ **`loading` «mavjud emas» matnini BERMAYDI.** `sanoq` hali
 * kelmaganda `paketlar` `undefined` bo'ladi va matn LIP-LIP qilib,
 * keyin diagrammaga sakrardi.
 */
export function LatenessHistogram({
	paketlar,
	kechikkan,
	loading = false,
}: LatenessHistogramProps) {
	const { t } = useTranslation("dashboard");

	if (loading) {
		return <Skeleton active paragraph={{ rows: 3 }} title={false} />;
	}

	if (paketlar?.length !== PAKET_SONI) {
		return (
			<Text type="secondary" className="text-xs">
				{t("lateness.unavailable")}
			</Text>
		);
	}

	// ⚠️ Balandlik ENG KATTA paketga NISBATAN: absolyut shkala («1 xodim
	// = 5 px») 200 kishilik bankda konteynerdan oshib ketardi.
	// ⚠️ `max === 0` (bugun hech kim kechikmagan) da `v / max` `0/0 =
	// NaN` beradi va `height: NaNpx` JIMGINA barcha ustunlarni
	// yo'qotardi.
	const max = Math.max(...paketlar);
	// ⚠️ `returnObjects: true` — qiymat MASSIV, i18next standart holatda
	// faqat `string` qaytaradi (namespace'dagi `lateness.buckets` besh
	// elementli qattiq kortej, tartib B ning `width_bucket` chegaralariga
	// mos, izohga qarang).
	const yorliqlar = t("lateness.buckets", { returnObjects: true }) as string[];

	return (
		<div>
			<div className="font-medium text-[12.5px]">{t("lateness.title")}</div>
			<Text type="secondary" className="block text-xs">
				{t("lateness.subtitle", { value: kechikkan })}
			</Text>

			<div className="mt-3 flex items-end gap-2" style={{ height: MAX_BALANDLIK + 20 }}>
				{paketlar.map((qiymat, indeks) => (
					<div
						// biome-ignore lint/suspicious/noArrayIndexKey: paketlar — o'rni MA'NOLI bo'lgan besh elementli kortej
						key={indeks}
						className="flex flex-1 flex-col items-center justify-end gap-1"
					>
						<span data-lateness-bucket className="text-xs tabular-nums">
							{qiymat}
						</span>
						<div
							data-lateness-bar
							className="w-full rounded-t-sm"
							style={{
								height: max === 0 ? 0 : Math.round((qiymat / max) * MAX_BALANDLIK),
								// ⚠️ UZUN xossa: test `el.style.backgroundColor` ni o'qiydi
								// va qisqartma `background` happy-dom'da uzun xossaga
								// yoyilmasligi mumkin — test RANGGA ALOQASI YO'Q sabab
								// bilan qizil bo'lardi.
								backgroundColor: DASHBOARD_RANGLARI.kechikkan,
							}}
						/>
					</div>
				))}
			</div>

			<div className="mt-1.5 flex gap-2">
				{yorliqlar.map((yorliq) => (
					<div key={yorliq} className="flex-1 text-center">
						<Text type="secondary" className="text-[10.5px]">
							{yorliq}
						</Text>
					</div>
				))}
			</div>
		</div>
	);
}
